<template>
	<div class="floor-style-3 floor-wsw floor-bgImg-box" :id="data.block_name+c_index">
		<div class="item-wrap">
			<div class="head-wrap">
				<div class="title-name" v-if="data.value.title.value.text">
					<span :style="{ backgroundColor: data.value.title.value.color }"></span>
					<h2 @click="$router.pushToTab(data.value.title.value.link.url)" :style="{ color: data.value.title.value.color }">{{ data.value.title.value.text }}</h2>
				</div>
				<div class="category-wrap">
					<li v-for="(item, index) in data.value.categoryList.value.list" :key="index">
						<router-link target="_blank" :to="{ path: '/list', query: { category_id: item.category_id, level: item.level } }">{{ item.category_name }}</router-link>
					</li>
				</div>
			</div>
			<div class="body-wrap">
				<div class="left-img-wrap">
					<img v-if="data.value.leftImg.value.url" :src="$img(data.value.leftImg.value.url)" @click="$router.pushToTab(data.value.leftImg.value.link.url)" />
				</div>
				<ul class="right-goods-wrap">
					<template v-for="(item, index) in data.value.rightGoodsList.value.list">
						<template v-if="index <= 7">
							<li class="hoverBox hoverBoder">
								<goods-list-item :goods="item" :upDownLayout="true"></goods-list-item>
							</li>
						</template>
					</template>
					
				</ul>
			</div>
			<div class="bottom-goods-wrap">
				<template v-for="(item, index) in data.value.bottomGoodsList.value.list">
					<div class="hoverBox hoverBoder">
						<goods-list-item imageSize="150" :goods="item" :upDownLayout="true" :isRow="true"></goods-list-item>
					</div>
				</template>
			</div>
		</div>
		<floorBgImg :info="data"></floorBgImg>
	</div>
</template>

<script>
import goodsListItem from "@/components/goods-list-item/goods-list-item.vue";
import floorBgImg from "./floor-bgImg.vue";
import { mapGetters } from 'vuex';
export default {
	name: 'floor-style-3',
	components: {
		goodsListItem,
        floorBgImg
	},
	props: {
		data: {
			type: Object
		},
		c_index:{
            type: Number
        }
	},
	data() {
		return {};
	},
	created() {},
	computed: {
		...mapGetters(['defaultGoodsImage'])
	},
	methods: {
		goSku(skuId) {
			this.$router.pushToTab('/sku-' + skuId);
		},
		imageErrorRight(index) {
			this.data.value.rightGoodsList.value.list[index].goods_image = this.defaultGoodsImage;
		},
		imageErrorBottom(index) {
			this.data.value.bottomGoodsList.value.list[index].goods_image = this.defaultGoodsImage;
		}
	}
};
</script>

<style lang="scss">
.item-wrap{
	position: relative;
	z-index: 2;
}
.floor-style-3 {
	overflow: hidden;
    background-color: #fff;
    margin-top: 20px;
	border-radius: 12px;

	.item-wrap .head-wrap {
		display: flex;
		align-items: baseline;
		justify-content: space-between;
		padding: 12px;
		box-sizing: border-box;
		.title-name {
			display: flex;
			align-items: center;
			gap: 6px;
			span {
				width: 5px;
				height: 21px;
			}
			h2 {
				font-weight: bold;
				font-size: 20px;
			}
		}
		.category-wrap {
			display: flex;
			gap: 12px;
		}
	}
	.body-wrap {
		display: flex;
		align-items: flex-start;
		.left-img-wrap {
			width: 234px;
			cursor: pointer;
			flex-shrink: 0;
			margin-right: 12px;
			img {
				max-width: 100%;
				max-height: 100%;
			}
		}
		.right-goods-wrap {
			display: flex;
			flex-wrap: wrap;
			gap: 12px;
			padding-right: 12px;
			box-sizing: border-box;
			li {
				width: calc((100% - 36px) / 4);
				flex-shrink: 0;
				background: #ffff;
				cursor: pointer;
                padding: 12px;
                border-radius: 12px;
                transition: all 0.2s linear;
                border: 1px solid #dddddd6e;
                box-sizing: border-box;
				&:hover {
                    z-index: 2;
                    -webkit-box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                    -webkit-transform: translate3d(0, -2px, 0);
                    transform: translate3d(0, -2px, 0);
                    border: 1px solid #dddddd6e;
                }
			}
		}
	}

	.bottom-goods-wrap{
		width: 100%;
		display: flex;
		align-items: stretch;
		padding: 12px;
		box-sizing: border-box;
		gap: 12px;
		overflow: hidden;
		>div{
			background: #fff;
			width: calc((100% - 24px) / 3);
			flex-shrink: 0;
			border-radius: 12px;
			transition: all 0.2s linear;
			border: 1px solid #dddddd6e;
			padding: 12px;
			box-sizing: border-box;
		}
	}

	.brand-wrap {
		display: flex;
		background: #fff;
		li {
			flex: 1;
			height: 50px;
			cursor: pointer;
			line-height: 50px;
			text-align: center;
			background: #fff;
			img {
				max-width: 100%;
				max-height: 100%;
			}
		}
	}
}
</style>
